var _extends2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

import { createElement, isValidElement, Component, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import get from 'lodash/get';
import set from 'lodash/set';
import { observer, Provider } from 'mobx-react';
import _hasIn from 'lodash/hasIn';
import { action, toJS, reaction, autorun, isObservable, observable, isObservableArray, isArrayLike } from 'mobx';
export { observable, action, computed } from 'mobx';
import { stringify, parse } from 'qs';
import _isEmpty from 'lodash/isEmpty';
import _every from 'lodash/every';
import _cloneDeep from 'lodash/cloneDeep';
import _isEqual from 'lodash/isEqual';
import _each from 'lodash/each';

/**
 * @file react-hyper
 * @author Cuttle Cong
 * @date 2018/2/13
 * @description
 */

var tags = ['div', 'span', 'a', 'img', 'pre', 'br', 'hr',

// 标题
'h1', 'h2', 'h3', 'h4', 'h5', 'h6',

// 表格相关
'table', 'thead', 'tbody', 'th', 'tr', 'td',

// 文档语义化
'aside', 'header', 'footer', 'section', 'article',

// 行内样式
'em', 'strong',

// 不建议使用
'i', 'b',

// 表单
'label', 'input', 'button', 'textarea', 'p', 'select', 'option', 'form',

// 列表
'ul', 'ol', 'li',

// media
'video', 'audio', 'iframe', 'colgroup', 'col', 'area', 'link'];

function hyper(tagName, classNameOrProps, props) {
  for (var _len = arguments.length, children = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    children[_key - 3] = arguments[_key];
  }

  if (typeof classNameOrProps === 'string') {
    props = props || {};
    props.className = props.className || classNameOrProps;
    return createElement.apply(this, [tagName, props].concat(children));
  }
  return createElement.apply(this, arguments);
}

tags.forEach(function (tag) {
  hyper[tag] = hyper.bind(null, tag);
});

/**
 * @file model-renderer-v2.js
 * @author Liang
 */

/**
 *
 * @def: DevPattern.renderer: (model, props, ...children) => ReactElem
 *  model: ViewModelInstance
 *
 *      // 用于默认渲染该 model
 *      defaultComp: ReactClass
 *
 *  // 额外的用于 react 渲染的 props
 *  props: {} | undefined
 *
 *      // 可被用来替换掉 model.defaultComp, 代替它渲染当前 viewModel
 *      comp: ReactClass
 *
 *  // 子 elems
 *  children: ReactElem...
 */
function renderer(model) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!model) {
    return null;
  }
  props = props || {};
  var Comp = props.comp || model.defaultComp;
  props.local = model;
  props.key = props.key || model.viewId;

  for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  return hyper.apply(undefined, [Comp, props].concat(children));
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass);
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

/**
 * @file mixedRenderer
 * @author Cuttle Cong
 * @date 2018/1/27
 * @description
 */

/**
 * `React.createElement` 是不能渲染一个 ViewModel 实例的，于是便提供了渲染方法来渲染 vm。
 *
 * 即可以 render ViewModel 也可以 render React Component
 * r -> model, props = {}, ...children
 * h -> tagOrComp, classNameOrProps, props = undefined, ...content
 */
/**
 *
 * 可以渲染 Vm 实例的方法，类似于 `React.createElement`
 * @name h
 * @public
 * @param {VmInstance | ReactComponent | string} model
 * @param {string | object} [propsOrClassName={}]
 * @param {object} [props=null]
 * @param {....ReactElement} [children=[]]
 * @returns {ReactElement}
 * @example
 * h(model, 'class-name', {},
 *  // children
 *  '1', '2'
 * );
 * h.div({}, 'inner')
 * h('div', {}, 'inner')
 * h('div', 'classname', {}, 'inner')
 * h(Component, 'classname', {},
 *    h.span()
 * )
 */
function mixedRenderer(model, propsOrClassName, props) {
  for (var _len = arguments.length, children = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    children[_key - 3] = arguments[_key];
  }

  if (model && (typeof model === 'undefined' ? 'undefined' : _typeof(model)) === 'object') {
    if (typeof propsOrClassName === 'string') {
      propsOrClassName = { className: propsOrClassName };
      props = props || {};
      props = _extends({}, props, propsOrClassName);
    } else {
      children = [props].concat(children);
      props = propsOrClassName;
    }
    return renderer.apply(this, [model, props].concat(children));
  }
  return hyper.apply(this, arguments);
}

Object.assign(mixedRenderer, hyper);

/**
 * @file reactUtils
 * @author Cuttle Cong
 * @date 2018/2/6
 * @description
 */

function isComponentInstance(instance) {
  return instance && instance instanceof Component;
}

// https://discuss.reactjs.org/t/how-to-determine-if-js-object-is-react-component/2825/5
function isComponentClass(component) {
  return component && component.prototype && component.prototype.isReactComponent && _typeof(component.prototype.isReactComponent) === 'object' && !Array.isArray(component.prototype.isReactComponent) ||
  // legacy ?
  component && component.prototype && isComponentInstance(component.prototype);
}

function assertReactClass(Component$$1, message) {
  if (!isComponentClass(Component$$1)) {
    throw new Error(message + ' require ReactClass');
  }
}

/**
 * 转换 ReactElem
 * @param element
 * @param rules: [[cond, process]]
 * @param parent
 * @return element
 */
function convertReactElement(element) {
  var rules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var outerIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  if (!element || rules.length === 0) {
    return element;
  }

  function convert(element, index, children) {
    rules.forEach(function (_ref) {
      var cond = _ref[0],
          handle = _ref[1];

      if (cond(element, index, parent, children)) {
        var handledElem = void 0;
        // eslint-disable-next-line no-cond-assign
        if (typeof (handledElem = handle(element, index, parent, children)) !== 'undefined') {
          element = handledElem;
        }
      }
    });

    // @thinking return element ?
    return element;
  }

  if (Array.isArray(element)) {
    return Children.toArray(element).map(function (elem, index) {
      return convertReactElement(elem, rules, parent, index);
    });
  }
  var children = element && element.props && element.props.children;
  var newElement = element;
  newElement = convert(element, outerIndex, children);
  // convert may update children
  var newChildren = newElement && newElement.props && newElement.props.children;
  if (newChildren) {
    newChildren = convertReactElement(newChildren, rules, newElement, outerIndex);
  }

  if (newElement === element && newChildren === children) {
    return element;
  }

  return isValidElement(newElement) ? cloneElement(newElement, newElement.props, newChildren) : newElement;
}

function displayName(component) {
  return component.displayName || component.name || component.type && (component.type.displayName || component.type.name) || 'Unknown';
}

/**
 * @file injectInverseInherit
 * @author Cuttle Cong
 * @date 2018/1/27
 * @description
 */

function injectCore(Comp) {
  var _class, _temp;

  return _temp = _class = function (_Comp) {
    inherits(Inject, _Comp);
    createClass(Inject, [{
      key: 'store',
      get: function get$$1() {
        return this.context.mobxStores;
      }
    }]);

    function Inject() {
      classCallCheck(this, Inject);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _this = possibleConstructorReturn(this, _Comp.call.apply(_Comp, [this].concat(args)));

      if (_this.store.app) {
        Object.defineProperty(_this, 'app', {
          get: function get$$1() {
            return this.store.app;
          },
          configurable: true
        });
      }
      return _this;
    }

    return Inject;
  }(Comp), _class.displayName = 'Inject-' + displayName(Comp), _class.contextTypes = _extends({}, Comp.contextTypes, {
    mobxStores: PropTypes.any
  }), _temp;
}

/**
 * 视图上注入全局 store
 * @public
 * @export
 * @name inject
 * @param {...string} [props=['app']]
 * @returns {function}
 * (ReactComponent) => InjectedComponent
 * @example
 * \@inject
 * class View extends React.Component {
 *    render() {
 *      // this.app
 *    }
 * }   
 */
function inject() {
  for (var _len2 = arguments.length, props = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    props[_key2] = arguments[_key2];
  }

  if (arguments.length === 1 && isComponentClass(arguments[0])) {
    return injectCore(arguments[0]);
  }

  if (!props.length) {
    props = ['app'];
  }
  var contextTypes = {};
  props.forEach(function (prop) {
    contextTypes[prop] = PropTypes.any;
  });

  return injectCore;
}

var fetch = function () {
  var _ref = asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof source === 'function')) {
              _context.next = 4;
              break;
            }

            _context.next = 3;
            return source();

          case 3:
            return _context.abrupt('return', _context.sent);

          case 4:
            return _context.abrupt('return', source);

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function fetch(_x) {
    return _ref.apply(this, arguments);
  };
}();

function fetchAndPush(ref, path) {
  return fetch(get(ref, path)).then(function (data) {
    set(ref, path, data);
  });
}

var symbol = typeof Symbol === 'function' ? Symbol('collect') : '--[[collect]]--';

/**
 * 收集全局 Store 的数据，一般在需要修改其他页面数据的时候使用；
 * 并且在使用了 webpack **异步加载VM**，搭配 `collect` 使用。
 *
 * 1. 支持直接调用 `const someVM = await collect(this.app.someVM)`
 * 2. 支持修饰器形式调用
 * @public
 * @param {...string} paths
 * @example <caption>app.js</caption>
 * \@bindView(ContainerView)
 * export default class App extends Root {
 *    // 懒加载，代码分割
 *    editVM = () => new Primise(resolve => {
 *      require.ensure([], () => resolve(require('./editVM')))
 *    })
 *    viewVM = () => new Primise(resolve => {
 *      require.ensure([], () => resolve(require('./viewVM')))
 *    })
 * }
 * @example <caption>routes.js</caption>
 * export default {
 *    path: '/',
 *    component: app,
 *    indexRoute: {
 *      getComponent: app.editVM
 *    },
 *    childRoutes: [
 *      {
 *        path: 'view',
 *        getComponent: app.viewVM
 *      }
 *    ]
 * }
 * @example <caption>View.js</caption>
 * \@collect('editVM', 'viewVM')
 * export default class View extends React.Component {
 *    render() {
 *      // 在这可以直接使用
 *      // this.app.editVM
 *      // this.app.viewVM
 *    }
 *
 *    // 在下面的生命周期中，不能直接使用
 *    // 需要 await collect(this.app.editVM) 来异步使用
 *    constructor() {}
 *    componentDidMount() {}
 *    componentWillMount() {}
 * }
 */
function collect() {
  for (var _len = arguments.length, paths = Array(_len), _key = 0; _key < _len; _key++) {
    paths[_key] = arguments[_key];
  }

  if (_typeof(paths[0]) === 'object' && !Array.isArray(paths[0]) || typeof paths[0] === 'function') {
    var source = paths[0];
    paths = paths.slice(1);
    // `collect(app.pageA)`
    if (!paths.length) {
      return fetch(source);
    }
    // `collect(app, 'pageA')` // should reset
    return Promise.all(paths.map(function (path) {
      return fetchAndPush(source, path);
    })).then(function () {
      return source;
    });
  }

  return function collectInner(Comp) {
    var _class, _temp;

    assertReactClass(Comp, 'collect');
    if (paths.length === 0) {
      return Comp;
    }

    var Collect = (_temp = _class = function (_Comp) {
      inherits(Collect, _Comp);

      function Collect() {
        classCallCheck(this, Collect);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var _this = possibleConstructorReturn(this, _Comp.call.apply(_Comp, [this].concat(args)));

        Promise.all(paths.map(function (path) {
          return fetchAndPush(_this.store.app, path);
        })).then(function () {
          _this[symbol] = 'resolved';
          _this.forceUpdate();
        });
        return _this;
      }

      Collect.prototype.render = function render() {
        if (this[symbol] !== 'resolved') {
          return null;
        }
        return _Comp.prototype.render.call(this);
      };

      return Collect;
    }(Comp), _class.displayName = 'Collect-' + displayName(Comp), _temp);

    return inject()(Collect);
  };
}

/**
 * @file model-comp-v2.js
 * @author Liang
 */
var symbol$1 = typeof Symbol === 'function' ? Symbol('model-comp') : '__model-comp__';

/**
 * 判断React Class是否为 ViewModal Component
 * @public
 * @param Comp {ReactClass}
 * @return {boolean}
 */
function isViewModelComponent(Comp) {
  return !!Comp[symbol$1];
}

function slice(props) {
  // eslint-disable-next-line no-unused-vars
  var local = props.local,
      rest = objectWithoutProperties(props, ['local']);

  return rest;
}

function modelComp(CompClass) {
  var _class, _temp;

  if (isViewModelComponent(CompClass)) {
    return CompClass;
  }

  var WrappedComp = (_temp = _class = function (_CompClass) {
    inherits(WrappedComp, _CompClass);

    function WrappedComp() {
      classCallCheck(this, WrappedComp);
      return possibleConstructorReturn(this, _CompClass.apply(this, arguments));
    }

    WrappedComp.prototype.componentDidMount = function componentDidMount() {
      if (this.props.local) {
        this.props.local.init && this.props.local.init(slice(this.props));
      }

      if (_CompClass.prototype.componentDidMount) {
        _CompClass.prototype.componentDidMount.apply(this, arguments);
      }
    };

    WrappedComp.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (nextProps.local !== this.props.local) {
        if (this.props.local.exit) {
          this.props.local.exit(slice(this.props));
        }
        if (nextProps.local.init) {
          nextProps.local.init(slice(nextProps));
        }
        if (_CompClass.prototype.componentWillReceiveProps) {
          _CompClass.prototype.componentWillReceiveProps.apply(this, arguments);
        }
        return;
      }

      if (this.props.local) {
        if (this.props.local.update) {
          this.props.local.update(slice(nextProps));
        } else if (this.props.local.init) {
          this.props.local.init(slice(nextProps));
        }
      }

      if (_CompClass.prototype.componentWillReceiveProps) {
        _CompClass.prototype.componentWillReceiveProps.apply(this, arguments);
      }
    };

    WrappedComp.prototype.componentWillUnmount = function componentWillUnmount() {
      this.props.local && this.props.local.exit && this.props.local.exit(slice(this.props));
      if (_CompClass.prototype.componentWillUnmount) {
        _CompClass.prototype.componentWillUnmount.apply(this, arguments);
      }
    };

    createClass(WrappedComp, [{
      key: 'local',
      get: function get$$1() {
        return this.props.local;
      }
    }]);
    return WrappedComp;
  }(CompClass), _class.displayName = 'VM-' + displayName(CompClass), _class[symbol$1] = true, _temp);

  return WrappedComp;
}

/**
 * @file bindView
 * @author Cuttle Cong
 * @date 2018/1/27
 * @description
 */

/**
 *
 * 用于绑定 ViewModel 中与 Model 中对应的 View
 * @export
 * @param {Function|ReactClass} View
 * @public
 * @example
 * class View extends React.Component {
 *    render() {
 *      this.local.abc === 'abc' // true
 *      this.local.cde === 'cde' // true
 *    }
 * }
 * \@bindView(View)
 * class Model extends Root {
 *    \@observable abc = 'abc'
 *    cde = 'cde'
 *    // ...
 * }
 * @returns {function} Model => BindedViewModel
 */
function bindView(View) {
  if (typeof View !== 'function') {
    throw new TypeError('bindView require View is function, but ' + (typeof View === 'undefined' ? 'undefined' : _typeof(View)));
  }
  // observer convert to react Class from function
  View = observer(View);
  View = modelComp(View);

  return function (State) {
    // let constructor = State.prototype.constructor
    // State.prototype.constructor = function () {
    //   Object.defineProperty(
    //     this, 'viewId',
    //     {
    //       value: View,
    //       enumerable: false,
    //       configurable: true,
    //       writable: true
    //     }
    //   )
    //   return constructor.apply(this, arguments)
    // }
    // State.prototype.constructor.name = constructor.name

    Object.defineProperty(State.prototype, 'defaultComp', {
      value: View,
      enumerable: false,
      configurable: true,
      writable: true
    });

    return State;
  };
}

/**
 * @file injectExt
 * @author Cuttle Cong
 * @date 2018/1/28
 * @description
 */

/**
 * 注入全局 store，并且可以进行一些额外操作.
 * @public
 * @export
 * @param {string} [name='app']
 * @param {function} action
 * @returns {function}
 * (ReactComponent) => InjectedComponent
 * @example
 * \@injectExt(app => {
 *   // some action here
 * })
 * class View extends React.Component {
 *    render() {
 *      // this.app
 *    }
 * }
 */
function injectExt(name, action$$1) {
  if (typeof name === 'function') {
    action$$1 = name;
    name = 'app';
  }
  if (typeof name === 'undefined') {
    name = 'app';
  }
  return function (Comp) {
    var _dec, _class, _class2, _temp;

    var InjectExt = (_dec = inject(name), _dec(_class = (_temp = _class2 = function (_Comp) {
      inherits(InjectExt, _Comp);

      function InjectExt() {
        classCallCheck(this, InjectExt);

        for (var _len = arguments.length, p = Array(_len), _key = 0; _key < _len; _key++) {
          p[_key] = arguments[_key];
        }

        var _this = possibleConstructorReturn(this, _Comp.call.apply(_Comp, [this].concat(p)));

        action$$1 && action$$1.call(_this, _this.store[name]);
        return _this;
      }

      return InjectExt;
    }(Comp), _class2.displayName = 'Ext-' + displayName(Comp), _temp)) || _class);

    return InjectExt;
  };
}

/**
 * @file collect
 * @author Cuttle Cong
 * @date 2018/1/28
 * @description
 */

var assign = action(function (rule, props, model) {
  // @action
  function setValue(propPath, modulePath) {
    if (_hasIn(props, propPath)) {
      var oldVal = get(model, modulePath);
      var newVal = get(props, propPath);
      if (newVal !== oldVal) {
        set(model, modulePath, newVal);
      }
    }
  }

  if (typeof rule === 'string') {
    setValue(rule, rule);
  } else if (Array.isArray(rule)) {
    rule.forEach(function (eachRule) {
      return assign(eachRule, props, model);
    });
  } else if ((typeof rule === 'undefined' ? 'undefined' : _typeof(rule)) === 'object') {
    for (var propPath in rule) {
      if (rule.hasOwnProperty(propPath)) {
        setValue(propPath, rule[propPath]);
      }
    }
  }
});

/**
 * 将 View 层的 props 同步映射至 model
 * @param mapper {[mapper] | {propName, modelName: string} | string}
 * @public
 * @returns {function} View => MappingView
 * @example
 * \@mapping(['abc.d', { 'prop': 'model' }])
 * class View extends React.Component {
 *    render() {
 *      // this.local.abc.d === this.props.abc.d
 *      // this.local.model === this.props.prop
 *    }
 * }
 */
function mapping(mapper) {
  if (!Array.isArray(mapper) && (typeof mapper === 'undefined' ? 'undefined' : _typeof(mapper)) !== 'object' && typeof mapper !== 'string') {
    throw new TypeError('@mapping(mapper): mapper require Array String or Object, but ' + (typeof mapper === 'undefined' ? 'undefined' : _typeof(mapper)));
  }

  return function mappingCore(Component$$1) {
    var _class, _temp;

    assertReactClass(Component$$1, 'mapping');

    var Mapping = (_temp = _class = function (_Component) {
      inherits(Mapping, _Component);

      function Mapping() {
        classCallCheck(this, Mapping);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Mapping.prototype.componentWillMount = function componentWillMount() {
        assign(mapper, this.props, this.local);
        _Component.prototype.componentWillMount && _Component.prototype.componentWillMount.apply(this, arguments);
      };

      Mapping.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
        assign(mapper, newProps, newProps.local);
        _Component.prototype.componentWillReceiveProps && _Component.prototype.componentWillReceiveProps.apply(this, arguments);
      };

      return Mapping;
    }(Component$$1), _class.displayName = 'Mapping-' + displayName(Component$$1), _temp);

    return Mapping;
  };
}

/**
 * @file stateless
 * @author Cuttle Cong
 * @date 2018/2/7
 * @description
 */

/**
 * 用于书写一些无组件自身状态的简单组件
 * @public
 * @param func {function} (local, props) => ReactElement
 * @param [localKey='local'] {string}
 * @example
 * export default stateless((local, props) =>
 *   <div></div>
 * )
 * @returns {function} props => ReactElement
 */
function stateless(func) {
  var localKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'local';

  return function wrappedStateless(props) {
    return func.apply(this, [this[localKey], props]);
  };
}

/**
 * @file   style-useable-hmr
 * @author yucong02
 */

/**
 * 绑定 Model 至 View 中，将会挂载一些 View 的[生命周期](../advanced/life-cycle.md)至 Model 中
 * @public 
 * @name stateInOut
 * @export
 * @param {function} StateClass 
 * @param {string} [keyName='local'] 
 * @param {object} [initData={}] 
 * @returns {function} View => View
 * @example
 * \@stateInOut(StateClass)
 * class View extends React.Component {
 *    render() {
 *      // this.local 可以访问 StateClass 的实例
 *    }
 * }
 */
function stateInOut(StateClass) {
  var keyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'local';
  var initData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return function (componentClass) {
    var _class, _temp;

    if (typeof initData === 'function') {
      initData = initData();
    }
    return _temp = _class = function (_componentClass) {
      inherits(SIO, _componentClass);

      // [refAPI]
      SIO.prototype.getState = function getState() {
        return this[keyName];
      };

      // [refAPI]


      SIO.prototype.getStateJSON = function getStateJSON() {
        return toJS(this[keyName]);
      };

      function SIO(p) {
        var _this, _ret;

        classCallCheck(this, SIO);

        var out = (_this = possibleConstructorReturn(this, _componentClass.call(this, p)), _this);
        _this[keyName] = typeof StateClass !== 'function' ? StateClass : new StateClass(initData);

        return _ret = out, possibleConstructorReturn(_this, _ret);
      }

      // WillMount 修改为 DidMount
      // 因为上一个 componentWillUnmount
      //  发生晚于 componentWillMount
      //      会出现先 注册 urlsync (componentWillMount)
      //      然后会立即注销 urlsync (componentWillUnmount)


      SIO.prototype.componentDidMount = function componentDidMount() {
        this[keyName].init && this[keyName].init(this.props);
        if (_componentClass.prototype.componentDidMount) {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _componentClass.prototype.componentDidMount.apply(this, args);
        }
      };

      SIO.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        if (this[keyName].update) {
          this[keyName].update(args[0]);
        } else if (this[keyName].init) {
          this[keyName].init(args[0]);
        }
        if (_componentClass.prototype.componentWillReceiveProps) {
          _componentClass.prototype.componentWillReceiveProps.apply(this, args);
        }
      };

      SIO.prototype.componentWillUnmount = function componentWillUnmount() {
        this[keyName].exit && this[keyName].exit(this.props);
        if (_componentClass.prototype.componentWillUnmount) {
          for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }

          _componentClass.prototype.componentWillUnmount.apply(this, args);
        }
      };

      return SIO;
    }(componentClass), _class.displayName = 'SIO-' + displayName(componentClass), _temp;
  };
}

// import logger from '../../utils/logger'


var core = function (_ref) {
  for (var _len = arguments.length, keyNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keyNames[_key - 1] = arguments[_key];
  }

  var _ref$init = _ref.init,
      init = _ref$init === undefined ? 'init' : _ref$init,
      _ref$exit = _ref.exit,
      exit = _ref$exit === undefined ? 'exit' : _ref$exit;

  if (!keyNames.length) {
    throw new Error('`reaction` should pass some refPaths');
  }

  var exited = {};
  keyNames = keyNames.filter(function (x) {
    if (exited[x]) {
      return false;
    }
    exited[x] = true;
    return true;
  });

  return function (target, property, descriptor) {
    if (typeof target[property] !== 'function') {
      throw new Error('`reaction` should used in member method');
    }

    var dispose = void 0;
    var originInit = target[init];
    target[init] = action(function () {
      var _this = this;

      // logger.debug(`reaction initialized : ${property}`)
      // 置前的原因请参考 autorun 置前的原因
      var rlt = originInit && originInit.apply(this, arguments);

      dispose = reaction(function () {
        return keyNames.map(function (refPath) {
          if (!_hasIn(_this, refPath)) {
            throw new Error('The reference path: ' + refPath + ' is not found.');
          }
          return get(_this, refPath);
        });
      }, function (args) {
        return target[property].apply(_this, args.concat(dispose));
      });
      return rlt;
    });

    var originExit = target[exit];
    target[exit] = function () {
      // logger.debug(`dispose reaction : ${property}`)
      dispose && dispose();
      return originExit && originExit.apply(this, arguments);
    };

    return descriptor && _extends({}, descriptor, { configurable: true });
  };
};

/**
 * @file index
 * @author Cuttle Cong
 * @date 2018/2/15
 * @description
 */

/** 
 * 发生改变之后，将会触发该成员方法
 * @name reaction
 * @public
 * @example
 * \@bindView(View)
 * class Model extends Root {
 *    \@observable val = '123'
 *    \@observable deep = { key: '123' }
 * 
 *    \@reaction('val', 'deep.key')
 *    reactionMethod(val, deepKey, dispose) {
 *      // 当 `this.val` `this.deep.key`
 *      // 发生改变之后，将会触发该方法
 *      // 与`autorun`不同的是，它第一次不会被触发
 *      
 *      // 调用 dispose 则会销毁掉该监听
 *      dispose && dispose()
 *    }
 * }
 */
var index = core.bind(null, {
  exit: 'exit',
  init: 'init'
});

/**
 * @file   index
 * @author yucong02
 */

/** global: __DEVELOPMENT__ */

function invokedWithArgs(args) {
  return args.length !== 3 || _typeof(args[0]) !== 'object' || typeof args[1] !== 'string' || _typeof(args[2]) !== 'object';
}

/**
 * @file debugLogger
 * @author Cuttle Cong
 * @date 2018/2/15
 * @description
 */
// import { debuglog } from 'util'

var logger = {
  debug: function debug() {
    if (global && global.VM_DEBUG && process.env.NODE_ENV !== 'production') {
      var _console;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_console = console).log.apply(_console, ['[react-mobx-vm] Debug:'].concat(args));
    }
  },
  warn: function warn() {
    var _console2;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    (_console2 = console).warn.apply(_console2, ['[react-mobx-vm] Warning:'].concat(args));
  },
  error: function error() {
    var _console3;

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    (_console3 = console).error.apply(_console3, ['[react-mobx-vm] Error:'].concat(args));
  }
};

/* eslint-disable */

var autorun$1 = function () {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var target = arguments[1];
  var property = arguments[2];
  var description = arguments[3];
  var _opt$initKey = opt.initKey,
      initKey = _opt$initKey === undefined ? 'init' : _opt$initKey,
      _opt$exitKey = opt.exitKey,
      exitKey = _opt$exitKey === undefined ? 'exit' : _opt$exitKey;

  if (typeof target[property] === 'function') {
    var release = function release() {
      logger.debug('dispose autorun `' + property + '`');
      dispose && dispose();
      dispose = null;
    };

    var wrapMethod = function wrapMethod(method, callback) {
      var callbackPlacement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'after';

      return function () {
        // urlsync 在 autorun 后面执行
        if (callbackPlacement === 'before') {
          callback && callback.call(this);
          return method && method.apply(this, arguments);
        }

        // autorun 在 urlsync 后面执行
        var rlt = method && method.apply(this, arguments);
        callback && callback.call(this);
        return rlt;
      };
    };

    var dispose = void 0;

    target[exitKey] = wrapMethod(target[exitKey], function () {
      release();
    }, 'before');

    target[initKey] = wrapMethod(target[initKey], function () {
      var _this = this;

      if (dispose) {
        return;
      }
      // logger.debug('load autorun `' + property + '`')
      dispose = autorun(function () {
        target[property].call(_this, dispose);
      });
    });
  } else {
    throw new Error('`autorun` should be used in member method');
  }

  return description && _extends({}, description, { configurable: true });
};

/* eslint-disable */

/**
 * 监听数据发生改变之后，将会触发该成员方法，不同于 reaction
 * @name autorun
 * @public
 * @example
 * \@bindView(View)
 * class Model extends Root {
 *    \@observable val = '123'
 *    \@observable deep = { key: '123' }
 *
 *    \@autorun
 *    autorunMethod(dispose) {
 *      // 当 `this.val`
 *      // 发生改变之后，将会触发该方法
 *      // 与`reaction`不同的是，它第一次初始化时会被触发
 *      console.log(this.val)
 *      // 调用 dispose 则会销毁掉该监听
 *      dispose && dispose()
 *    }
 * }
 */
var index$1 = function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (invokedWithArgs(args)) {
    throw new Error('`autorun` don\'t need pass some arguments');
  }
  return autorun$1.apply(undefined, [{ initKey: 'init', exitKey: 'exit' }].concat(args));
};

/**
 * @file proxy
 * @author Cuttle Cong
 * @date 2018/1/23
 * @description
 */

function proxy(host, path, getValue) {
  var old = get(host, path);
  var newVal = getValue(old);
  set(host, path, newVal);
  return newVal;
}

var symbol$2 = typeof Symbol === 'function' ? Symbol('bindable') : '__[[bindable]]__';

var bindableTags = {};
function unBindable(CompOrTagName) {
  if (typeof CompOrTagName === 'string') {
    delete bindableTags[CompOrTagName];
  } else if (isComponentClass(CompOrTagName)) {
    delete CompOrTagName[symbol$2];
  }
}

function normalize(value) {
  // 支持 string
  if (typeof value === 'string') {
    return [[value]];
  }

  if (Array.isArray(value)) {
    value = value.map(function (val) {
      if (Array.isArray(val)) {
        return val;
      }
      return [val];
    });
    return value;
  }
  throw new TypeError('bindable options requires string or array, but ' + (typeof value === 'undefined' ? 'undefined' : _typeof(value)));
}

function normalizeOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    return options.map(function (opt) {
      return normalizeOptions(opt);
    });
  }

  var _options$prop = options.prop,
      prop = _options$prop === undefined ? [] : _options$prop,
      _options$event = options.event,
      event = _options$event === undefined ? [] : _options$event,
      rest = objectWithoutProperties(options, ['prop', 'event']);

  prop = normalize(prop);
  event = normalize(event);
  return _extends({
    prop: prop,
    event: event
  }, rest);
}

/**
 * 如果你需要写一些自定义的 bindable 规则，可能你需要用到默认的配置
 * @see [bindable](#bindable)
 * @public
 *
 */
var DEFAULT_OPTIONS = normalizeOptions({
  // 该批次 process 的条件判断
  cond: null,
  // value 对应的属性名
  prop: ['value'],
  // value 改变的事件名
  event: ['onChange']
});

/**
 *
 * @param Component elem/Comp/tagName
 * @return {*}
 */
function getOptionsList(Component$$1) {
  if (isValidElement(Component$$1)) {
    return Component$$1.type && getOptionsList(Component$$1.type);
  }
  if (typeof Component$$1 === 'string') {
    return bindableTags[Component$$1.toLowerCase()];
  }
  return Component$$1 && Component$$1[symbol$2];
}

function getHandledProps(ctx, elementOrComponent, oldProps) {
  var optList = getOptionsList(elementOrComponent) || [DEFAULT_OPTIONS];

  var props = _extends({}, oldProps);
  optList.some(function (opt) {
    if (typeof opt.cond === 'function' && !opt.cond(oldProps, ctx)) {
      return false;
    }
    opt.prop.forEach(function (_ref) {
      var name = _ref[0],
          transform = _ref[1];

      if (typeof transform !== 'function') {
        transform = function transform(v) {
          return v;
        };
      }
      // overwrite value
      props[name] = transform(ctx.get(), oldProps[name], oldProps, ctx);
    });

    opt.event.forEach(function (_ref2) {
      var name = _ref2[0],
          handle = _ref2[1];

      if (typeof handle !== 'function') {
        handle = function handle(_ref3) {
          var event = _ref3[0];

          return event && _typeof(event.target) === 'object' && 'value' in event.target ? event.target.value : event;
        };
      }
      proxy(props, name, function (onChange) {
        return asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          for (var _len = arguments.length, argvs = Array(_len), _key = 0; _key < _len; _key++) {
            argvs[_key] = arguments[_key];
          }

          var rlt, newValue;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.t0 = onChange;

                  if (!_context.t0) {
                    _context.next = 5;
                    break;
                  }

                  _context.next = 4;
                  return onChange.apply(this, argvs);

                case 4:
                  _context.t0 = _context.sent;

                case 5:
                  rlt = _context.t0;

                  if (!(rlt !== false)) {
                    _context.next = 11;
                    break;
                  }

                  // continue, not skip
                  newValue = handle.apply(this, [argvs, ctx]);

                  // handle will be regard as transform
                  // when return something

                  if (typeof newValue !== 'undefined') {
                    ctx.set(newValue);
                  }
                  _context.next = 12;
                  break;

                case 11:
                  return _context.abrupt('return', rlt);

                case 12:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
      });
    });
    return true;
  });

  return props;
}

/**
 * 搭配[binding](#binding)使用，可以定义自己的 binding 规则
 * @public
 * @param [options=DEFAULT_OPTIONS] {object}
 * @param [options.cond=null] {function} props => boolean
 *       是否匹配上
 * @param [options.prop=['value']] {[[propName: string, transform: function] | string]}
 *       需要绑定的属性定义，可以通过 transform 进行转换
 * @param [options.event=['onChange']] {[[propName: string, handler: function] | string]}
 *       需要绑定的属性定义，可以通过 transform 进行转换
 * @param tagName {String | ReactComponent}
 *   被绑定的组件，可以为 HTML标签名 或 ReactComponent
 * @return {Bindable}
 * @see [examples/binding#bindable](../examples/binding.md#bindable)
 * @example
 * bindable([{
 *    cond: function (props) {
 *      return props.type === 'checkbox'
 *    },
 *    prop: [
 *      ['checked', function (modelValue, propVal, props) {
 *        return modelValue.includes(props.name)
 *      }]
 *    ],
 *    event: [
 *      ['onChange', function ([evt], ctx) {
 *        const { target: { name, checked } } = evt
 *        const list = ctx.get()
 *        let i = list.indexOf(name)
 *        i >= 0 && list.splice(i, 1)
 *        if (checked) {
 *          list.push(name)
 *        }
 *      }]
 *    ]
 *  }].concat(DEFAULT_OPTIONS), 'input')
 *
 *  class Scope {
 *    \@observable value = 'val'
 *    \@observable checkedList = []
 *  }
 *  const scope = new Scope
 *
 *  \@observer
 *  class View extends React.Component {
 *    render() {
 *      return (
 *        <div>
 *          {binding(scope)(
 *            <input type="text" id="text" data-bind="value" data-scope={scope}/>,
 *            <input type="checkbox" id="a_0" data-bind="checkedList" name={'a'}/>,
 *            <input type="checkbox" id="a_1" data-bind="checkedList" name={'a'}/>,
 *            <input type="checkbox" id="b_0" data-bind="checkedList" name={'b'}/>,
 *          )}
 *          <input id="test" data-bind="value"/>
 *        </div>
 *      )
 *    }
 *  }
 *
 */
function bindable(options, tagName) {
  options = options || DEFAULT_OPTIONS;
  options = normalizeOptions(options);
  if (!Array.isArray(options)) {
    options = [options];
  }

  if (typeof tagName === 'string') {
    bindableTags[tagName.toLowerCase()] = options;
    return;
  }
  if (typeof tagName === 'function') {
    tagName[symbol$2] = options;
    return tagName;
  }

  return function Bindable(Component$$1) {
    Component$$1[symbol$2] = options;
    return Component$$1;
  };
}

function convert(element, fallbackScope) {
  return convertReactElement(element, [[function cond(elem) {
    return elem && elem.props && elem.props.hasOwnProperty('data-bind');
  }, function (elem) {
    var bind = elem.props['data-bind'];
    var dataScope = elem.props['data-scope'] || fallbackScope;

    if (!dataScope) {
      throw new Error('binding convert require data-scope, but ' + dataScope);
    }

    // dynamic bind
    if (typeof bind === 'function') {
      bind = bind(dataScope).toString();
    }
    var get$$1 = function get$$1() {
      return get(dataScope, bind.toString());
    };
    var set$$1 = action(function (val) {
      set(dataScope, bind.toString(), val);
    });
    if (process.env.NODE_ENV !== 'production' && !isObservable(dataScope)) {
      console.warn('[Warning] the scope of binding isn\'t observable.', dataScope);
    }
    var ctx = {
      get: get$$1,
      set: set$$1,
      scope: dataScope,
      bind: bind
    };

    if (bind !== '' && _hasIn(dataScope, bind) || typeof bind === 'function') {
      var handledProps = getHandledProps(ctx, elem, elem.props);
      var newProps = _extends({}, elem.props, handledProps);
      newProps['data-bind'] = newProps['data-scope'] = void 0;
      return cloneElement(elem, newProps);
    }

    console.warn('binding ' + bind + ' failed, Don\'t find the property in', dataScope);
    return elem;
  }]]);
}

function isMemberMethod() {
  return arguments.length === 3 && _typeof(arguments[0]) === 'object' && !isValidElement(arguments[0]) && typeof arguments[1] === 'string' && _typeof(arguments[2]) === 'object' && !isValidElement(arguments[2]);
}

function bindMemberMethod(maybeScope) {
  return function () {
    // @binding member method
    if (isMemberMethod.apply(this, arguments)) {
      var descriptor = arguments[2];
      if ('value' in descriptor && typeof descriptor.value === 'function') {
        return _extends({}, descriptor, {
          value: function value() {
            return convert(descriptor.value.apply(this, arguments), maybeScope || this.local);
          }
        });
      }
      if ('get' in descriptor) {
        return _extends({}, descriptor, {
          get: function get$$1() {
            return convert(descriptor.get.call(this), maybeScope || this.local);
          }
        });
      }
      // getter
      throw new Error('@binding member method or getter, but ' + JSON.stringify(descriptor));
    }
  };
}

function bindClassOrFunc(maybeScope) {
  return function (element) {
    if (isComponentClass(element)) {
      var _class, _temp;

      var Binding = (_temp = _class = function (_element) {
        inherits(Binding, _element);

        function Binding() {
          classCallCheck(this, Binding);
          return possibleConstructorReturn(this, _element.apply(this, arguments));
        }

        Binding.prototype.render = function render() {
          return convert(_element.prototype.render.call(this), maybeScope || this.local);
        };

        return Binding;
      }(element), _class.displayName = 'Binding-' + displayName(element), _temp);

      return observer(Binding);
    }
    if (typeof element === 'function') {
      return observer(function WrappedBinding() {
        // maybeScope -> scope
        return convert(element.apply(this, arguments), maybeScope || this.local);
      });
    }
  };
}

/**
 *
 * 简易的双向绑定写法，默认绑定 `value/onChange` 的一个闭环
 * @public
 * @name binding
 * @example
 * \@bindView(View)
 * class Model extends Root {
 *    \@observable abc = '123'
 * }
 * // 一劳永逸的用法
 * \@binding
 * class View extends React.Component {
 *    render() {
 *      return (
 *        <div>
 *          <input data-bind="abc" />
 *        </div>
 *      )
 *    }
 * }
 *
 * class View extends React.Component {
 *    // 在成员方法里面修饰
 *    \@binding
 *    renderSomething() {
 *      // return ...
 *    }
 *    // 在getter方法里面修饰
 *    \@binding
 *    get Something() {
 *      // return ...
 *    }
 *    render() {
 *      // 或者绑定指定的 react-element
 *      return (
 *        <div>
 *          {binding(this.local)(
 *            <input data-bind="abc" />
 *          )}
 *          // 或者直接传入 element
 *          // 注意：需要绑定 `data-scope` 作用域
 *          {binding(<input data-bind="abc" data-scope={this.local} />)}
 *        </div>
 *      )
 *    }
 * }
 *
 */
function binding(element) {

  var newClass = bindClassOrFunc.apply(this, [null]).apply(this, arguments);
  if (newClass) {
    return newClass;
  }

  // @binding member method
  var descriptor = bindMemberMethod.apply(this, [null]).apply(this, arguments);
  if (descriptor) {
    return descriptor;
  }

  // binding(scope)(...element)
  if (element !== null && (typeof element === 'undefined' ? 'undefined' : _typeof(element)) === 'object' && !isValidElement(element)
  // @thinking
  && isObservable(element)) {
    return function bindedScope() {
      // @binding(scope)(Component)
      if (arguments.length === 1 && typeof arguments[0] === 'function') {
        return bindClassOrFunc.apply(this, [element]).apply(this, arguments);
      }
      // @binding(scope) memberMethod
      if (isMemberMethod.apply(this, arguments)) {
        return bindMemberMethod.apply(this, [element]).apply(this, arguments);
      }
      if (arguments.length === 0) {
        return;
      }
      return convert(arguments.length === 1 ? arguments[0] : [].concat(Array.prototype.slice.call(arguments)), element);
    };
  }

  return arguments.length === 1 ? convert(element) : convert([].concat(Array.prototype.slice.call(arguments)));
}

/**
 * @file stateLife
 * @author Cuttle Cong
 * @date 2018/2/4
 * @description
 */

var assignState = action(function (self, property, val) {
  var setVal = function setVal() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : val;

    if (self[property] !== value) {
      logger.debug(name + ' set', property, value);
      self[property] = value;
    }
  };

  if (typeof val !== 'undefined') {
    logger.debug('before load `' + property + '`:', self[property]);
    if (val == null) {
      setVal();
    } else if (_typeof(self[property]) === 'object' && self[property] !== null) {
      if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
        // remove overflow items if arrays
        if (Array.isArray(val) && (isObservableArray(self[property]) || Array.isArray(self[property])) && val.length < self[property].length) {
          self[property].splice(val.length, self[property].length - val.length);
        }
        if (Array.isArray(val)) {
          val.forEach(function (v, k) {
            return assignState(self[property], k, v);
          });
        } else {
          for (var k in val) {
            if (val.hasOwnProperty(k)) {
              assignState(self[property], k, val[k]);
            }
          }
        }
      }
    } else if (typeof self[property] === 'number') {
      setVal(parseFloat(val));
    } else if (typeof self[property] === 'boolean') {
      setVal(typeof val === 'boolean' ? val : val === 'true');
    } else {
      setVal();
    }

    logger.debug('after load: `' + property + '`:', self[property]);
  }
});

// const g = {}
function setHideProps(target, propKey, value) {
  Object.defineProperty(target, propKey, {
    value: value,
    configurable: true,
    enumerable: false
  });
}

var getStateLifeDecorator = function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'state-life';

  config = config || {};
  // const collection = g[name] = g[name] || {}

  return function (urlKey) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var target = arguments[2];
    var property = arguments[3];
    var descriptor = arguments[4];

    if (typeof urlKey !== 'string') {
      options = _extends({}, options, urlKey);
      urlKey = property;
    }
    options = options || {};
    var _options = options,
        _options$initKey = _options.initKey,
        initKey = _options$initKey === undefined ? 'init' : _options$initKey,
        _options$exitKey = _options.exitKey,
        exitKey = _options$exitKey === undefined ? 'exit' : _options$exitKey,
        updateKey = _options.updateKey;

    var assignStateValue = function assignStateValue(self, property, urlKey) {
      return assignState(self, property, config.get(urlKey));
    };

    if ('value' in descriptor && typeof descriptor.value === 'function') {
      throw new Error('`' + name + '` can NOT use in member method');
    }

    if ('initializer' in descriptor) {
      logger.warn('`' + property + '`' + 'is unobservable,', name, 'would make it to be observable.');
      descriptor = observable(target, property, descriptor);
    }
    var hideArrPropKey = '__[[' + name + '_hooks]]__';

    // NOTE:
    // class P {
    //    @urlSync s = 'a'
    // }
    // class S extends P {
    //    @urlSync s = 'a'
    // }
    // new S() --> should run the S.s hooks, ignore P hooks
    // Firstly!
    if (!target[hideArrPropKey]) {
      setHideProps(target, hideArrPropKey, []);
    }
    // inheritance
    else if (!target.hasOwnProperty(hideArrPropKey)) {
        // set to Prototype
        setHideProps(target, hideArrPropKey, target[hideArrPropKey].slice());
      }
    var i = target[hideArrPropKey].findIndex(function (_ref) {
      var p = _ref[0];
      return p === property;
    });
    if (i >= 0) {
      target[hideArrPropKey].splice(i, 1);
    }
    var func = function (options, urlKey, property) {
      var dispose = void 0;
      var syncUrlTimer = void 0;
      var _syncUrlFn = void 0;
      function runLazyNow() {
        if (syncUrlTimer) {
          clearTimeout(syncUrlTimer);
          _syncUrlFn && _syncUrlFn();
          syncUrlTimer = void 0;
          _syncUrlFn = void 0;
        }
      }

      // eslint-disable-next-line no-inner-declarations
      function release() {
        dispose && dispose();
        dispose = null;
        runLazyNow();
      }

      return {
        init: function init() {
          var _this = this;

          config.init && config.init(this, property, urlKey);
          logger.debug('init ' + name + ' `' + property + '`');
          release();
          assignStateValue(this, property, urlKey);

          var isFirst = true;
          dispose = autorun(function () {
            var _obj;

            // 一段时间内的修改以最后一次为准
            if (syncUrlTimer) {
              clearTimeout(syncUrlTimer);
              syncUrlTimer = void 0;
            }

            var obj = (_obj = {}, _obj[urlKey] = _this[property], _obj);
            // invoke the deep `getter` of this[property]
            // noop op
            try {
              JSON.stringify(obj);
            } catch (err) {
              console.error('[Stringify]', obj, 'Error happened:', err);
            }

            _syncUrlFn = function syncUrlFn() {
              var isFirst = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

              var save = isFirst ? config.saveFirstTime || config.save : config.save;
              // toJS for fix ObservableArray can't be stringify
              save.call(config, urlKey, toJS(_this[property]), config.fetch());
              syncUrlTimer = void 0;
              _syncUrlFn = void 0;
            };

            if (isFirst) {
              if (options.initialWrite) {
                _syncUrlFn(true);
              }
              isFirst = false;
              return;
            }
            syncUrlTimer = setTimeout(_syncUrlFn, 250);
          });
        },
        update: function update() {
          // The vm's model has the below link rule (two vm instances)
          // x -> y
          // a -> b -> c

          // It's time that trigger `x` syncUrlTimer would cause the url updated
          // Then trigger update hook like above link rule
          // So we need run `runLazyNow` in update hook
          runLazyNow();
          assignStateValue(this, property, urlKey);
        },
        exit: function exit() {
          config.exit && config.exit(this, property, urlKey);
          logger.debug('dispose ' + name + ' `' + property + '`');
          release();
        }
      };
    }(options, urlKey, property);
    // const arrays =
    target[hideArrPropKey].push([property, urlKey, func]);

    var hooks = {
      init: target[initKey],
      update: target[updateKey],
      exit: target[exitKey]
    };
    var callHook = function callHook(self, hookName, args) {
      return typeof hooks[hookName] === 'function' && hooks[hookName].apply(self, args);
    };

    target[initKey] = function () {
      var _this2 = this;

      this[hideArrPropKey].forEach(function (_ref2) {
        var init = _ref2[2].init;

        init.call(_this2);
      });

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return callHook(this, initKey, args);
    };
    if (updateKey) {
      target[updateKey] = function () {
        var _this3 = this;

        this[hideArrPropKey].forEach(function (_ref3) {
          var update = _ref3[2].update;

          update.call(_this3);
        });

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return callHook(this, updateKey, args);
      };
    }
    target[exitKey] = function () {
      var _this4 = this;

      // @todo setTimeout move to all for better performance.
      this[hideArrPropKey].forEach(function (_ref4) {
        var init = _ref4[2].init;

        init.call(_this4);
      });

      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return callHook(this, exitKey, args);
    };

    return descriptor && _extends({}, descriptor, { configurable: true });
  };
};

/* eslint-disable */
function stringify$1(obj) {
  return '?' + stringify(obj);
}

function parse$1() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  string = string.trim();
  if (string.startsWith('?')) {
    string = string.substring(1);
  }
  return parse(string);
}

var useHistory = void 0;
/**
 * @namespace urlSync
 * @example
 * @name registerUrlSync
 * @public
 * @export
 * @param {RouterHistory} history
 *  [See more information](https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/api/history.md)
 * @example
 * import { hashHistory, Router } from 'react-router'
 * registerUrlSync(hashHistory)
 *
 * <Router routes={routes} history={hashHistory} />
 */
function register(history) {
  useHistory = history;
}

function assertHistory() {
  if (!useHistory) {
    console.error('Error: You DO NOT \`register(history)\` before using urlSync. ' + 'NOTE: \`history\` should be from \'history\' or \'react-router\'');
    throw new Error('NOT `register(history)`');
  }
}

var urlsync = getStateLifeDecorator({
  /*init(self, property, name) {
    assertHistory()
    checkExistedName(name)
    collection[name] = assignState.bind(null, self, property)
    if (unlisten) {
      // unListen previous listener
      return
    }
    unlisten = useHistory.listen(
      action(
        location => {
          if (location.action === 'POP') {
            location.query = parse(location.search)
            Object
              .keys(collection)
              .forEach(name => {
                const assign = collection[name]
                if (name in location.query) {
                  assign(location.query[name])
                }
              })
          }
        }
      )
    )
  },*/
  /*exit(self, property, name) {
    delete collection[name]
  },*/
  // saveFirstTime(key, value, data) {
  //   assertHistory()
  //   useHistory.replace({
  //     ...data,
  //     search: stringify({ ...data.query, [key]: value }),
  //     query: null
  //   })
  // },
  save: function save(key, value, data) {
    var _babelHelpers$extends;

    assertHistory();
    if (value && value.toJSON && typeof value.toJSON === 'function') {
      value = value.toJSON();
    }

    useHistory.replace(_extends({}, data, {
      search: stringify$1(_extends({}, data.query, (_babelHelpers$extends = {}, _babelHelpers$extends[key] = value, _babelHelpers$extends))),
      query: null
    }));
  },
  fetch: function fetch() {
    assertHistory();
    var location = useHistory.getCurrentLocation();
    location.query = parse$1(location.search);
    return location;
  },
  get: function get$$1(key) {
    assertHistory();
    return this.fetch().query[key];
  }
}, 'urlsync');

/**
 * @file index
 * @author Cuttle Cong
 * @date 2017/11/6
 * @description
 */

var keyMap = {
  initKey: 'init',
  updateKey: 'update',
  exitKey: 'exit'

  /**
   * 用于同步状态至 URL
   * @namespace urlSync
   * @name urlSync
   * @example
   * class Model extends Root {
   *   \@urlSync
   *   \@observable sync = 'abc'
   *   // 未使用 @observable 修饰, urlSync会自动将其转为 observable
   *   \@urlSync('g')
   *   value = 'abcdef'
   * }
   * @public
   */
};function urlSync(urlKeyOrTarget, property, descriptor) {
  if (invokedWithArgs(arguments)) {
    var options = property;
    return function (target, property, descriptor) {
      return urlsync(urlKeyOrTarget || property, _extends({}, keyMap, options), target, property, descriptor);
    };
  }

  return urlsync(property, keyMap, urlKeyOrTarget, property, descriptor);
}

/**
 * @file urlSync
 * @author Cuttle Cong
 * @date 2017/11/6
 * @description
 */

/* eslint-disable */

var keyName = '--[storage-sync]--';

var sync = getStateLifeDecorator({
  save: function save(key, value, state) {
    var _babelHelpers$extends;

    localStorage.setItem(keyName, JSON.stringify(_extends({}, state, (_babelHelpers$extends = {}, _babelHelpers$extends[key] = value, _babelHelpers$extends))));
  },
  fetch: function fetch() {
    var str = localStorage.getItem(keyName);
    try {
      return JSON.parse(str) || {};
    } catch (ex) {
      return {};
    }
  },
  get: function get$$1(key) {
    return this.fetch()[key];
  }
}, 'storage-sync');

/**
 * @file index
 * @author Cuttle Cong
 * @date 2017/11/6
 * @description
 */

var keyMap$1 = {
  initKey: 'init',
  updateKey: 'update',
  exitKey: 'exit'

  /**
   * Model层的数据（localStorage）存储同步
   * @public
   * @name storageSync
   * @param [storageKey=property] {string}
   * @param options {string} 参考{@link #reacturlsync|reactUrlSync}
   * @example
   * class Model extends Root {
   *    \@storageSync
   *    \@observable data = { arr: [1, 2, 3] }
   * }
   * // 在修改了 `model.data` 之后，查看 `localStorage` 中的数据
   */
};function state(urlKeyOrTarget, property, descriptor) {
  if (invokedWithArgs(arguments)) {
    var options = property;
    return function (target, property, descriptor) {
      return sync(urlKeyOrTarget || property, _extends({}, keyMap$1, options), target, property, descriptor);
    };
  }

  return sync(property, keyMap$1, urlKeyOrTarget, property, descriptor);
}

/**
 * @file index
 * @author Cuttle Cong
 * @date 2017/11/6
 * @description
 */

/**
 * @file index
 * @author Cuttle Cong
 * @date 2017/11/6
 * @description
 */

var keyMap$2 = {
  initKey: 'componentDidMount',
  updateKey: 'componentWillReceiveProps',
  exitKey: 'componentWillUnmount'

  /**
   * View 层的数据（localStorage）存储同步
   * @public
   * @name reactStorageSync
   * @param [storageKey=property] {string}
   * @param options {string} 参考{@link #reacturlsync|reactUrlSync}
   */
};function react(urlKeyOrTarget, property, descriptor) {
  if (invokedWithArgs(arguments)) {
    var options = property;
    return function (target, property, descriptor) {
      return sync(urlKeyOrTarget || property, _extends({}, keyMap$2, options), target, property, descriptor);
    };
  }

  return sync(property, keyMap$2, urlKeyOrTarget, property, descriptor);
}

/**
 * @file index
 * @author Cuttle Cong
 * @date 2017/11/6
 * @description
 */

var keyMap$3 = {
  initKey: 'componentDidMount',
  updateKey: 'componentWillReceiveProps',
  exitKey: 'componentWillUnmount'

  /**
   * 用于同步状态至 URL，不同于 [`urlSync`](#urlsync) 的地方是，`reactUrlSync` 用于 react 视图层
   * @namespace urlSync
   * @name reactUrlSync
   * @param [urlKey=property] {string} - 状态对应URL上的 key
   * @param [options] {Object} - 选项
   * @param [options.initialWrite=false] {boolean}
   *  是否在第一次加载时候，将状态值写至 URL
   * @example
   *  class View extends React.Component {
   *      \@reactUrlSync
   *      \@observable sync = 'abc'
   *  }
   * @public
   */
};function react$1(urlKeyOrTarget, property, descriptor) {
  if (invokedWithArgs(arguments)) {
    var options = property;
    return function (target, property, descriptor) {
      return urlsync(urlKeyOrTarget || property, _extends({}, keyMap$3, options), target, property, descriptor);
    };
  }

  return urlsync(property, keyMap$3, urlKeyOrTarget, property, descriptor);
}

/**
 * @file react
 * @author Cuttle Cong
 * @date 2018/2/15
 * @description
 */

/** 
 * 发生改变之后，将会触发该成员方法
 * @name reactReaction
 * @public
 * @example
 * class View extends React.Component {
 *    \@observable val = '123'
 *    \@observable deep = { key: '123' }
 * 
 *    \@reaction('val', 'deep.key')
 *    reactionMethod(val, deepKey, dispose) {
 *      // 当 `this.val` `this.deep.key`
 *      // 发生改变之后，将会触发该方法
 *      // 与`autorun`不同的是，它第一次不会被触发
 *      
 *      // 调用 dispose 则会销毁掉该监听
 *      dispose && dispose()
 *    }
 * }
 */
var react$2 = core.bind(null, {
  init: 'componentDidMount',
  exit: 'componentWillUnmount'
});

/**
 * @file   autorun
 * @author yucong02
 */

var keyMap$4 = {
  initKey: 'componentDidMount',
  updateKey: 'componentWillReceiveProps',
  exitKey: 'componentWillUnmount'

  /**
   * 发生改变之后，将会触发该成员方法
   * @name reactAutorun
   * @public
   * @example
   * class View extends React.Component {
   *    \@observable val = '123'
   *    \@observable deep = { key: '123' }
   *
   *    \@autorun
   *    autorunMethod(dispose) {
   *      // 当 `this.val`
   *      // 发生改变之后，将会触发该方法
   *      console.log(this.val)
   *      // 调用 dispose 则会销毁掉该监听
   *      dispose && dispose()
   *    }
   * }
   */
};var react$3 = function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (invokedWithArgs(args)) {
    throw new Error('`autorun` don\'t need pass some arguments');
  }
  return autorun$1.apply(undefined, [keyMap$4].concat(args));
};

/**
 * @file index
 * @author Cuttle Cong
 * @date 2018/2/14
 * @description
 */

/**
 * @file addHideProps
 * @author Cuttle Cong
 * @date 2018/4/20
 * @description
 */

function addHideProps(ref, prop, value) {
  Object.defineProperty(ref, prop, {
    value: value,
    enumerable: false,
    configurable: true,
    writable: true
  });
}

/**
 * @file increaseId
 * @author Cuttle Cong
 * @date 2018/2/13
 * @description
 */

var id = 1;

function get$2() {
  return id++;
}

var _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 *
 * 建议所以的 Model 都继承自该类，提供了一些方法
 * @typedef Root
 * @public
 * @export
 * @class Root
 */
var Root = (_class = function () {
  /**
   * 建议使用给方法创建实例对象，而不是 `new Model()` 原因参看 https://github.com/imcuttle/babel-plugin-class-properties-default-value
   * @static
   * @public
   * @param {object} [init={}]
   * @returns {Root}
   * @memberof Root
   * @example
   * class Model extends Root {
   *    val = 123
   * }
   * const model = Model.create({ val: '345' })
   */
  Root.create = function create() {
    var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return new this().assign(init);
  };

  /**
   * 该方法对应与 React 的 componentDidMount 生命周期
   * @public
   * @param {object} props - View 中的 `this.props`
   * @memberof Root
   */

  Root.prototype.init = function init() /* props */{};

  /**
   * 该方法对应与 React 的 componentWillReceiveProps 生命周期
   * @public
   * @param {object} props - View 中的 `nextProps`
   * @memberof Root
   */

  Root.prototype.update = function update() {};

  /**
   * 该方法对应与 React 的 componentWillUnmount 生命周期
   * @public
   * @param {object} props - View 中的 `this.props`
   * @memberof Root
   */

  Root.prototype.exit = function exit() {};

  /**
   * 将 this 转换为 JSON
   * @public
   * @memberof Root
   */

  Root.prototype.toJSON = function toJSON() {
    var _this = this;

    var data = {};
    Object.keys(this).forEach(function (name) {
      // 嵌套支持
      if (_this[name] && typeof _this[name].toJSON === 'function') {
        data[name] = _this[name].toJSON();
      } else {
        data[name] = _this[name];
      }
    });
    return toJS(data);
  };

  /**
   *
   * 设置当前对象中 key 的值
   * @param {string | array} key
   * @param {any} value
   * @returns {Root}
   * @public
   * @memberof Root
   * @example
   * Root
   *  .create()
   *  .setValue('a', {})
   *  .setValue('a.b', '123')
   *  .setValue(['a', 'b'], '456')
   */

  Root.prototype.setValue = function setValue(key, value) {
    set(this, key, value);
    return this;
  };

  function Root() {
    var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    classCallCheck(this, Root);

    addHideProps(this, 'viewId', get$2());

    this.assignShallow(init);
  }

  Root.prototype.assignShallow = function assignShallow(data) {
    data = toJS(data);
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        // if (typeof data[key] !== 'undefined') {
        if (this[key] instanceof Root) {
          this[key].assignShallow(data[key]);
        } else {
          this[key] = data[key];
        }
        // }
      }
    }
    return this;
  };

  /**
   *
   * 拷贝当前对象
   * @returns {Root}  一个新的实例
   * @public
   * @memberof Root
   */

  Root.prototype.clone = function clone() {
    return this.constructor.create(this);
  };

  /**
   * 对比两个对象是否相同
   * @param {any} other
   * @returns {boolean}
   * @memberof Root
   * @public
   * @example
   * Root.create().isEqual({}) // true
   * Root.create({ a: [1, 3] }).isEqual({ a: [1, 3] }) // true
   * Root.create({ a: [1, 3] }).isEqual(Root.create({ a: [1, 3] })) // true
   */

  Root.prototype.isEqual = function isEqual(other) {
    return this === other || _isEqual(this.toJSON(), other instanceof Root ? other.toJSON() : other);
  };

  /**
   * 批量赋值，如需要覆写 `assign`，请覆写 `assignShallow`
   * @param {object | Root} data
   * @returns {Root}
   * @memberof Root
   * @alias assignShallow
   * @public
   * @example
   * Root
   *  .create()
   *  .assign({ a: 'a', b: 'b' })
   *  .assignShallow({ a: 'a', b: 'b' })
   * // 支持嵌套赋值
   * class Nested extends Root {
   *   \@observable root = Root.create({ a: 'c' })
   * }
   * Nested
   *  .create({ root: { b: 'b' } })
   *  .root instanceof Root // true
   * Nested
   *  .create({ root: { b: 'b' } })
   *  .root.a === 'c' // true
   */

  Root.prototype.assign = function assign(data) {
    return this.assignShallow(data);
  };

  /**
   *  深拷贝批量赋值
   * @see [assign](#assign)
   * @param {object | Root} data
   * @returns {Root}
   * @memberof Root
   * @public
   * @example
   * const a = Root.create().assignDeep({ a: 'a', b: 'b' })
   */

  Root.prototype.assignDeep = function assignDeep(data) {
    data = _cloneDeep(toJS(data, false));
    return this.assignShallow(data);
  };

  /**
   *  判断当前实例是否内容为空
   * @see [assign](#assign)
   * @returns {Root}
   * @memberof Root
   * @public
   * @example
   * Root.create().isEmpty() // true
   * Root.create({ a: '', b: [] }).isEmpty() // true
   * Root.create({ a: '', b: [], c: Root.create() }).isEmpty() // true
   * Root.create({ a: 'a', b: [] }).isEmpty() // false
   * Root.create({ a: '', b: ['a'] }).isEmpty() // false
   */

  Root.prototype.isEmpty = function isEmpty() {
    return _every(this, function (value) {
      if (value instanceof Root) {
        return value.isEmpty();
      }
      return _isEmpty(value);
    });
  };

  return Root;
}(), _applyDecoratedDescriptor(_class.prototype, 'setValue', [action], Object.getOwnPropertyDescriptor(_class.prototype, 'setValue'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'assignShallow', [action], Object.getOwnPropertyDescriptor(_class.prototype, 'assignShallow'), _class.prototype), _class);

/**
 * @file Piped
 * @author Cuttle Cong
 * @date 2018/1/29
 * @description
 */

/**
 * 
 * 其对 Root 中的 init/update 进行的无差别的赋值，
 * 如果你需要对 View 中的 props 一股脑都同步至 Model 中，
 * 则可以通过继承该类来实现
 * @public
 * @export
 * @class Piped
 * @extends {Root}
 */

var Piped = function (_Root) {
  inherits(Piped, _Root);

  function Piped() {
    classCallCheck(this, Piped);
    return possibleConstructorReturn(this, _Root.apply(this, arguments));
  }

  Piped.prototype.init = function init(_init) {
    this.assignShallow(_init);
  };

  Piped.prototype.update = function update(init) {
    this.assignShallow(init);
  };

  return Piped;
}(Root);

function nearestRefPath(ref, paths) {
  if (typeof paths === 'string') {
    paths = paths.split('.');
  }
  // 取得最近的 ref
  // join('.') 为了 'a.b' 作为ref 的情况
  var latestPaths = paths.slice(0, paths.length - 1).join('.');
  if (latestPaths.length) {
    ref = get(ref, latestPaths);
  }
  var path = paths[paths.length - 1];
  return {
    ref: ref,
    path: path
  };
}

function defineDeepProperties(target) {
  var properites = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _each(properites, function (val, key) {
    var _nearestRefPath = nearestRefPath(target, key),
        ref = _nearestRefPath.ref,
        path = _nearestRefPath.path;

    if (!ref) {
      throw new Error('defineDeepProperties: ref is null.');
    }
    Object.defineProperty(ref, path, _extends({
      configurable: true,
      enumerable: true
    }, val));
  });

  return target;
}

// const symbolicKey = typeof Symbol === 'function' ? Symbol('__symbolic__') : '__[symbolic]__'
/**
 * 用于建立 target 与外接的连接，类似于[Symbolic Link](https://en.wikipedia.org/wiki/Symbolic_link).
 * @see [SymbolicLink](./others.md#symboliclink)
 * @example
 *  let host = { a: 'a' }
 *  const proxy = { a: 'x' }
 *  host = symbolic(host, {
 *    'a': Symbolic(proxy, 'a')
 *  })
 *  host.a === 'x'
 * @name symbolicLink
 * @public
 * @param target
 * @param config
 */
function symbolicLink(target) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var properties = {};
  _each(config, function (symbol, keyName) {
    if (!(symbol instanceof Symbolic)) {
      throw new TypeError('symbolic requires the instanceof Symbolic(Custom).');
    }
    var rule = symbol.rule;
    // SymbolicCustom
    if (rule && !Array.isArray(rule) && (typeof rule === 'undefined' ? 'undefined' : _typeof(rule)) === 'object') {
      properties[keyName] = rule;
      return;
    }

    var ref = rule[0];
    var paths = rule[1];

    // Deep observable ref can't access now.
    // Would trigger lazy initializer about mobx.
    // Some amazing error would be thrown
    // let { ref: nearestRef, path } = nearestRefPath(ref, paths)

    // if (process.env.NODE_ENV !== 'production' && !isObservable(nearestRef, path)) {
    //   console.warn('[Warning]: the symbolic origin ref is unobservable.', 'ref:', nearestRef, ' path:', path)
    // }
    // if (typeof nearestRef === 'undefined') {
    //   throw new Error('symbolicLink requires nearestRef')
    // }
    properties[keyName] = {
      get: function get$$1() {
        return get(ref, paths);
      },
      set: function set$$1(val) {
        set(ref, paths, val);
      }
    };
  });

  // hack mobx @observable
  if (target.__mobxLazyInitializers && target.__mobxLazyInitializers.push) {
    target.__mobxLazyInitializers.push(function symbolicLinkDefine(instance) {
      defineDeepProperties(instance, properties);
    });
  }

  return defineDeepProperties(target, properties);
}

/**
 * @file SymbolicLink
 * @author Cuttle Cong
 * @date 2018/3/16
 * @description
 */

// TODO: 提供只util是不是更好?

/**
 * 用于创建链接对象
 * @see {SymbolicLink}
 * @public
 * @param ref {Object}
 * @param path {String}
 * @return {Symbolic}
 * @constructor
 */
function Symbolic(ref, path) {
  if (!(this instanceof Symbolic)) {
    return new Symbolic(ref, path);
  }
  this.rule = [ref, path];
}

/**
 * 用于自定义的链接关系
 * @see {SymbolicLink}
 * @public
 * @param descriptor {object}
 * @return {SymbolicCustom}
 * @constructor
 * @extends {Symbolic}
 * @example
 * SymbolicCustom({
 *   get() {}
 *   set() {}
 * }, 'value')
 */
function SymbolicCustom(descriptor) {
  if (!(this instanceof SymbolicCustom)) {
    return new SymbolicCustom(descriptor);
  }
  this.rule = descriptor;
}
SymbolicCustom.prototype = Object.create(Symbolic.prototype);
SymbolicCustom.prototype.constructor = SymbolicCustom;

function calcSymbolic(value) {
  var symbolic = void 0;
  if (value instanceof Symbolic) {
    symbolic = value;
  }
  return symbolic;
}

/**
 * 用于链接自己的引用到其他的地方
 *
 * @public
 * @export
 * @class SymbolicLink
 * @extends {Root}
 * @example
 * import { SymbolicLink, Root } from 'react-mobx-vm'
 * class Model extends SymbolicLink {
 *   \@observable title = 'modelTitle'
 * }
 *
 * class Parent extends Root {
 *    model = Model.create().setSymbolic('title', Symbolic(this, 'title'))
 *
 *    \@observable title = 'abc'
 * }
 *
 * const parent = Parent.create()
 * parent.model.title === parent.title // true
 * parent.title === 'abc' // true
 */

var SymbolicLink = function (_Root) {
  inherits(SymbolicLink, _Root);

  function SymbolicLink() {
    classCallCheck(this, SymbolicLink);
    return possibleConstructorReturn(this, _Root.apply(this, arguments));
  }

  /**
   * 单独设置 Symbolic
   * @example
   * model.setSymbolic('title', Symbolic(this, 'abc'))
   * @public
   * @memberOf {SymbolicLink}
   * @param path {String|Array}
   * @param symbolic {Symbolic}
   * @return {Root}
   */
  SymbolicLink.prototype.setSymbolic = function setSymbolic(path, symbolic) {
    var _symbolicLink;

    var computedSymbolic = calcSymbolic(symbolic);
    computedSymbolic && symbolicLink(this, (_symbolicLink = {}, _symbolicLink[path] = computedSymbolic, _symbolicLink));
    return this;
  };

  return SymbolicLink;
}(Root);

/**
 * @file inherit
 * @author Cuttle Cong
 * @date 2018/4/20
 * @description
 */

function inherit(Child, Super) {
  var extendStatics = Object.setPrototypeOf || _extends2({}, []) instanceof Array && function (Child, Super) {
    _defaults(Child, Super);
  } || function (Child, Super) {
    for (var p in Super) {
      if (Super.hasOwnProperty(p)) Child[p] = Super[p];
    }
  };
  extendStatics(Child, Super);
  // Node Version
  Child.super_ = Super;
  function __() {
    this.constructor = Child;
  }
  Child.prototype = Object.setPrototypeOf ? Object.setPrototypeOf(Child.prototype, Super.prototype) : Super === null ? Object.create(Super) : (__.prototype = Super.prototype, new __());
}

/**
 * @file List
 * @author Cuttle Cong
 * @date 2018/4/12
 * @description
 */

function _extends$1(obj, defaults$$1) {
  var keys = Object.getOwnPropertyNames(defaults$$1);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var value = Object.getOwnPropertyDescriptor(defaults$$1, key);
    if (value && (value.configurable || typeof value.get === 'function' || typeof value.set === 'function') && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }
  return obj;
}

var classCallCheck$1 = function classCallCheck$$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
};

var ObservableArray = observable.array([]).constructor;

/**
 * List 定义数组类型，非常适合于定义 Modal 后，使用`assign`方法一次性赋值
 * @typedef List
 * @public
 * @param init {any[]}
 * @param Type {Function}
 * @param options {object}
 * @constructor
 * @example
 *
 * class Model extends Root {
 *   \@observable a = 'xyz'
 *   \@observable b = 'abc'
 * }
 *
 * const list = List.create([{ a: 'xbb' }, { b: 'hhh' }], Model)
 *
 * list[0] instanceof Model === true
 * list[1] instanceof Model === true
 *
 * list.assign([{ a: 'xxx' }])
 * list[0] instanceof Model === true
 * list.length === 1
 */
function List() {
  var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var Type = arguments[1];
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  classCallCheck$1(this, List);
  var arr = observable.array([], options);
  ObservableArray.apply(this, [[], arr.$mobx.enhancer]);

  addHideProps(this, '_Type', Type);
  this.assign(init);
}

inherit(List, Root);
_extends$1(List.prototype, ObservableArray.prototype);
_extends$1(List.prototype, Array.prototype);

/**
 *
 * @param init {Array}
 * @param Type {FunctionConstructor?}
 * @param options {object?}
 * @return {Root}
 */
List.create = function create() {
  var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var Type = arguments[1];
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return new this([], Type, options).assign(init);
};
List.prototype._new = function _new(item) {
  if (this._Type && typeof this._Type.create === 'function') {
    if (item instanceof this._Type) {
      return item;
    }
    return this._Type.create(item);
  }
  return new this._Type(item);
};

var originUnshift = List.prototype.unshift;
List.prototype.unshift = action(function unshift() {
  for (var _len = arguments.length, items = Array(_len), _key = 0; _key < _len; _key++) {
    items[_key] = arguments[_key];
  }

  if (typeof this._Type === 'function') {
    items = items.map(this._new.bind(this));
  }
  return originUnshift.apply(this, items);
});

var originPush = List.prototype.push;
List.prototype.push = action(function push() {
  for (var _len2 = arguments.length, items = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    items[_key2] = arguments[_key2];
  }

  if (typeof this._Type === 'function') {
    items = items.map(this._new.bind(this));
  }
  return originPush.apply(this, items);
});
List.prototype.assignShallow = action(function assignShallow() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (!isArrayLike(items)) {
    throw new Error('List#assignShallow requires data which is like array, but ' + (typeof items === 'undefined' ? 'undefined' : _typeof(items)));
  }

  this.splice(0, this.length);
  this.push.apply(this, items);
  return this;
});

List.prototype.toJSON = function () {
  return toJS(this);
};

/**
 * @file index
 * @author Cuttle Cong
 * @date 2018/2/14
 * @description
 */

/**
 * @file Provider
 * @author Cuttle Cong
 * @date 2018/2/16
 * @description
 */

/**
 * 用于产生一个 Provider，传入一个全局的 store
 * @public
 * @name providerFactory
 * @example
 * const app = AppVM.create()
 * const Provider = providerFactory(app)
 * 
 * ReactDOM.render(
 *    <Provider>
 *      {...}
 *    </Provider>,
 *    window.root
 * )
 */
var providerFactory = function (app) {
  return function Provider$$1(_ref) {
    var children = _ref.children,
        props = objectWithoutProperties(_ref, ['children']);

    return createElement(Provider, _extends({}, props, {
      app: app
    }), children);
  };
};

var version = "0.2.0";

/**
 * @file index
 * @author Cuttle Cong
 * @date 2018/2/14
 * @description
 */

export { mixedRenderer as h, symbolicLink, providerFactory, isViewModelComponent, version, collect, bindView, injectExt, inject, mapping, stateless, stateInOut, index as reaction, index$1 as autorun, binding, bindable, urlSync, state as storageSync, react as reactStorageSync, react$1 as reactUrlSync, react$2 as reactReaction, react$3 as reactAutorun, unBindable, DEFAULT_OPTIONS, register as registerUrlSync, Root, Piped, SymbolicLink, List, Symbolic, SymbolicCustom };
//# sourceMappingURL=react-mobx-vm.es.js.map